import { useDispatch, useSelector } from "react-redux";
export function createTypedHooks() {
    const useRootDispatch = () => useDispatch();
    const useRootSelector = useSelector;
    return { useRootDispatch, useRootSelector };
}
//# sourceMappingURL=reduxHooks.js.map